import { lazy } from 'react';

const LazyAddShiftErrorAlert = lazy(() => import('./AddShiftErrorAlert'));
const LazyDeleteShiftErrorAlert = lazy(() => import('./DeleteShiftErrorAlert'));
const LazyAddShiftModal = lazy(() => import('./AddShiftModal'));
const LazyDeleteShiftModal = lazy(() => import('./DeleteShiftModal'));
const LazyDeleteReasonModal = lazy(() => import('./DeleteReasonModal'));
const LazyDeleteReasonSuccessToast = lazy(
  () => import('./DeleteReasonSuccessToast')
);
const LazyDeleteReasonErrorAlert = lazy(
  () => import('./DeleteReasonErrorAlert')
);
const LazyAddShiftSuccessToast = lazy(() => import('./AddShiftSuccessToast'));
const LazyAddReasonSuccessToast = lazy(() => import('./AddReasonSuccessToast'));
const LazyAddReasonErrorAlert = lazy(() => import('./AddReasonErrorAlert'));
const LazyLogoutModal = lazy(() => import('./LogoutModal'));
const LazyCloseWeekModal = lazy(() => import('./CloseWeekModal'));
const LazyCloseWeekSuccessToast = lazy(() => import('./CloseWeekSuccessToast'));
const LazyCloseWeekErrorAlert = lazy(() => import('./CloseWeekErrorAlert'));
const LazyDeleteShiftSuccessToast = lazy(
  () => import('./DeleteShiftSuccessToast')
);
const LazyCopyTextSuccessToast = lazy(() => import('./CopyTextSuccessToast'));
const LazyAddReasonModal = lazy(() => import('./AddReasonModal'));

export {
  LazyAddReasonErrorAlert,
  LazyAddReasonModal,
  LazyAddReasonSuccessToast,
  LazyAddShiftErrorAlert,
  LazyAddShiftModal,
  LazyAddShiftSuccessToast,
  LazyCloseWeekErrorAlert,
  LazyCloseWeekModal,
  LazyCloseWeekSuccessToast,
  LazyCopyTextSuccessToast,
  LazyDeleteReasonErrorAlert,
  LazyDeleteReasonModal,
  LazyDeleteReasonSuccessToast,
  LazyDeleteShiftErrorAlert,
  LazyDeleteShiftModal,
  LazyDeleteShiftSuccessToast,
  LazyLogoutModal
};
